"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreSpaceCountingMode = exports.CoreSpaceSafeThresholdMode = exports.CoreSpaceSizeAreaUnit = exports.CoreSpaceFunction = exports.CoreSpaceType = void 0;
var CoreSpaceType;
(function (CoreSpaceType) {
    CoreSpaceType["SPACE"] = "space";
    CoreSpaceType["FLOOR"] = "floor";
    CoreSpaceType["BUILDING"] = "building";
    CoreSpaceType["CAMPUS"] = "campus";
})(CoreSpaceType = exports.CoreSpaceType || (exports.CoreSpaceType = {}));
var CoreSpaceFunction;
(function (CoreSpaceFunction) {
    CoreSpaceFunction["BREAK_ROOM"] = "break_room";
    CoreSpaceFunction["CAFE"] = "cafe";
    CoreSpaceFunction["COLLABORATION"] = "collaboration";
    CoreSpaceFunction["CONFERENCE_ROOM"] = "conference_room";
    CoreSpaceFunction["DINING_AREA"] = "dining_area";
    CoreSpaceFunction["EVENT_SPACE"] = "event_space";
    CoreSpaceFunction["FOCUS_QUIET"] = "focus_quiet";
    CoreSpaceFunction["GYM"] = "gym";
    CoreSpaceFunction["KITCHEN"] = "kitchen";
    CoreSpaceFunction["LAB"] = "lab";
    CoreSpaceFunction["LIBRARY"] = "library";
    CoreSpaceFunction["LOUNGE"] = "lounge";
    CoreSpaceFunction["MEETING_ROOM"] = "meeting_room";
    CoreSpaceFunction["OFFICE"] = "office";
    CoreSpaceFunction["PHONE_BOOTH"] = "phone_booth";
    CoreSpaceFunction["PLACE_OF_WORSHIP"] = "place_of_worship";
    CoreSpaceFunction["RECEPTION"] = "reception";
    CoreSpaceFunction["RESTROOM"] = "restroom";
    CoreSpaceFunction["RETAIL"] = "retail";
    CoreSpaceFunction["THEATER"] = "theater";
    CoreSpaceFunction["WELLNESS_ROOM"] = "wellness_room";
})(CoreSpaceFunction = exports.CoreSpaceFunction || (exports.CoreSpaceFunction = {}));
var CoreSpaceSizeAreaUnit;
(function (CoreSpaceSizeAreaUnit) {
    CoreSpaceSizeAreaUnit["SQUARE_FEET"] = "square_feet";
    CoreSpaceSizeAreaUnit["SQUARE_METERS"] = "square_meters";
})(CoreSpaceSizeAreaUnit = exports.CoreSpaceSizeAreaUnit || (exports.CoreSpaceSizeAreaUnit = {}));
var CoreSpaceSafeThresholdMode;
(function (CoreSpaceSafeThresholdMode) {
    CoreSpaceSafeThresholdMode["SAFE_CAPACITY"] = "SAFE_CAPACITY";
    CoreSpaceSafeThresholdMode["UTILIZATION_PERC_LEGAL"] = "UTILIZATION_PERC_LEGAL";
    CoreSpaceSafeThresholdMode["UTILIZATION_PERC_TARGET"] = "UTILIZATION_PERC_TARGET";
})(CoreSpaceSafeThresholdMode = exports.CoreSpaceSafeThresholdMode || (exports.CoreSpaceSafeThresholdMode = {}));
var CoreSpaceCountingMode;
(function (CoreSpaceCountingMode) {
    CoreSpaceCountingMode["NONE"] = "none";
    CoreSpaceCountingMode["DOORWAYS"] = "doorways";
    CoreSpaceCountingMode["SUM_EXPLICIT"] = "sum_explicit";
    CoreSpaceCountingMode["SUM_CHILDREN"] = "sum_children";
})(CoreSpaceCountingMode = exports.CoreSpaceCountingMode || (exports.CoreSpaceCountingMode = {}));
//# sourceMappingURL=spaces.js.map